const Section3 = () => {
  return (
    <div className="text-base leading-6 text-justify space-y-4 text-content">
      <br />
      <h2 className=" font-inter font-semibold text-lg leading-none tracking-normal mb-8 text-dark">
        <strong>Definitions </strong>
      </h2>
      <p className="font-inter font-normal text-base leading-6 tracking-normal text-justify">
        <strong>Jumaconnect Account </strong> The account you open or sign in on
        Jumaconnect to use the Services. We reserve the right to suspend or
        terminate your Account due to inaccurate, untrue, or incomplete
        information, or failure to comply with the account registration
        requirements.
      </p>
    <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Jumaconnect Account History </strong> A summary of account usage
        activities which may include transactions and statements on your
        account.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Fees </strong> The surcharges deducted from your account for
        services rendered, which are percentages of the payment.
      </p>

      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Payment </strong> The service charge for the Service rendered by
        the Service Provider on a pay-as-you-go basis.
      </p>
      <br/>

      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Balance </strong> The transactional value or amount held in your
        account.
      </p>
      <br/>

      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Hold of Settlement </strong> The right to defer settlement or
        restrict access to proceeds if we need to conduct an investigation or
        resolve any pending dispute related to your use of the service or by
        order of the courts.
      </p>
      <br/>

      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>License and Restriction </strong> The right granted to you in
        accordance with these Terms of Service.
      </p>
      <br/>

      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Off-set Right: </strong> To the extent permitted by law, we may
        set off against your Balances for any obligation You owe us under any
        Agreement (e.g., Chargebacks or refunds).
      </p>
      <br/>

      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Chargebacks </strong> Chargebacks are claims on disputed
        transactions.
      </p>
      <br/>

      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Contesting Chargebacks: </strong> You shall assist us when
        requested, at your expense, to investigate any of your transactions
        processed through the Jumaconnect Services and we shall release
        corresponding reserved funds to your Jumaconnect Account if contesting
        chargebacks is successful.
      </p>
      <br/>

      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        Excessive Chargebacks:If we believe You might incur, or you are
        incurring, an excessive amount of Chargebacks, we may establish
        additional conditions governing your Jumaconnect Account.
      </p>
      <br/>

      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Termination and Suspension: </strong> You are free to stop using
        the Jumaconnect Services anytime, and we reserve the right to suspend or
        terminate your Jumaconnect account upon breach or abuse of the Service
        in accordance with the general terms.
      </p>
      <br/>

      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Security: </strong> We have implemented technical and
        organizational measures designed to secure your personal information,
        but you are responsible for safeguarding your password and restricting
        access to the Services.
      </p>
      <br/>

      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Indemnity: </strong> You hold Jumaconnect and its processors
        (and its respective employees, directors, agents, affiliates, and
        representatives) harmless from and against any and all claims, costs,
        losses, damages, judgments, tax assessments, penalties, interest, and
        expenses that you may incur from your use of the Services.
      </p>
      <br/>

      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Consent and Notice: </strong> You consent to accept and receive
        communications from Jumaconnect, including e-mail, text messages, and
        calls to the cellular telephone number and e-mail address you provide to
        us. Notice on Service use will be sent via these means. Revision and
        Amendment: At any time with notice, we may update, amend, or revise the
        Jumaconnect Services, including websites, software, hardware, and other
        products. Use of Services on behalf of a Business: If you are using the
        Services on behalf of a business, that business accepts and agrees to
        these General Terms and any policies referenced within. Jumaconnect
        Account Registration: You must open an account with Jumaconnect (a
        “Jumaconnect Account”) to use the Services. During registration, we will
        ask you to provide information, including your name and other personal
        information. You must provide accurate and complete information in
        response to our questions, and keep that information current. You are
        fully responsible for all activity that occurs under your Account,
        including for any actions taken by persons to whom you have granted
        access to the use of your Account. We reserve the right to suspend or
        terminate the Account of any user who provides inaccurate, untrue, or
        incomplete information, or who fails to comply with the account
        registration requirements.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Use of Information: </strong> We may use information about you
        to maintain and improve our Services, such as:
        <ul className="list-disc pl-6">
          <li>
            Processing or recording payment transactions or money transfers.
          </li>
          <li>Displaying historical transaction or appointment information.</li>
          <li>Developing new products and Services.</li>
          <li>
            Delivering the information and support you request, including
            technical notices, security alerts, and support and administrative
            messages.
          </li>
        </ul>
      </p>
      <br/>

      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Revisions: </strong> We may amend or revise the General Terms,
        any Additional Terms, or our Policies, at any time with notice that we
        deem to be reasonable in the circumstances, by updating the revised
        version on our website or communicating it to you through the Services
        (each a “Revised Version”). The Revised Version will be effective as of
        the time it is posted, but will not apply retroactively. Your continued
        use of the Services after the posting of a Revised Version constitutes
        your acceptance of such Revised Version.
      </p>
      <br/>

      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Amendment: </strong> From time to time, we may add, make changes
        to, or remove altogether features or functionality of the Services on
        our website. Notice of Change or Amendment:We may notify you of such
        changes from time to time via email or by displaying a message when you
        next use the Jumaconnect services. If you continue to use Jumaconnect
        Services, your use will be governed by the updated Terms.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Disclosures: </strong> We may provide disclosures and notices
        required by law and other information about your Account to you
        electronically, by posting it on our website, pushing notifications
        through the Services, or by emailing it to the email address listed in
        your Jumaconnect Account. Electronic disclosures and notices have the
        same meaning and effect as if we had provided you with paper copies.Such
        disclosures and notices are considered received by you within
        twenty-four (24) hours of the time posted to our website, or within
        twenty-four (24) hours of the time emailed to you unless we receive
        notice that the email was not delivered.
      </p>
      <br/>

      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Restrictions: </strong>
        Transmit any material that is defamatory, offensive or otherwise
        objectionable in relation to your use of Jumaconnect Limited; Use
        Jumaconnect Limited in a way that could damage, disable, overburden,
        impair or compromise our systems or security or interfere with other
        users; Collect or harvest any information or data from Jumaconnect
        website or our systems or attempt to decipher any transmissions to or
        from the servers running any Jumaconnect Services;
        <br />
        Disclose or distribute information relating to another User of the
        Jumaconnect website to any third party, or use any other User’s
        information for any marketing purposes unless you have that User’s
        express permission to do so. Access or register User logins via bots or
        other automated methods.
      </p>
      <br/>

      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>No malicious or illegal use: </strong>
        You may not and also not permit any third party, directly or indirectly,
        to: access or monitor any material or information on any Jumaconnect
        system using any manual process or robot, spider, scraper, or other
        automated means; except to the extent that any restriction is expressly
        prohibited by law, violate the restrictions in any robot exclusion
        headers on any Service, workaround, bypass, or circumvent any of the
        technical limitations of the Services, use any tool to enable features
        or functionalities that are otherwise disabled in the Services, or
        decompile, disassemble or otherwise reverse engineer the Services;
        perform or attempt to perform any actions that would interfere with the
        proper working of the Services, prevent access to or use of the Services
        by our other clients, or impose an unreasonable or disproportionately
        large load on our infrastructure; copy, reproduce, alter, modify, create
        derivative works, publicly display, republish, upload, post, transmit,
        resell or distribute in any way material, information or Services from
        Jumaconnect.
        <br />
        You will not upload or provide Content or otherwise post, transmit,
        distribute, or disseminate through the Services any material that: (a)
        is false, misleading, unlawful, obscene, indecent, lewd, pornographic,
        defamatory, libelous, threatening, harassing, hateful, abusive, or
        inflammatory. If we reasonably suspect that your Jumaconnect Account has
        been used for an unauthorized, illegal, or criminal purpose, You give us
        express authorization to share information about you, your Jumaconnect
        Account, and any of your activities with law enforcement agencies,
        organizations or institutions.
      </p>
      <br/>

      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Mobile Devices Compatibility: </strong> We do not warrant that
        the Services will be compatible with your mobile device. Your use of the
        Services may be subject to the terms of your agreements with your mobile
        device manufacturer. You may not use a modified device to use the
        Services if the modification is contrary to the manufacturer’s software
        or hardware guidelines, including disabling hardware or software
        controls sometimes referred to as “jail broken.”
      </p>
      <br/>

      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Your Content: </strong> The Services may include functionality
        for uploading or providing photos, logos, jobs, loyalty programs,
        promotions, advertisements and other materials or information
        (“Content”). You grant us and our subsidiaries, affiliates, and
        successors a worldwide, non-exclusive, royalty-free, fully paid,
        transferable, and sub-licensable right to use, reproduce, modify, adapt,
        publish, prepare derivative works of, distribute, publicly perform, and
        publicly display your Content throughout the world in any media in order
        to provide and promote the Services. You retain all rights in your
        Content, subject to the rights you granted to us in these General Terms.
        You may modify or remove your Content via your Jumaconnect Account or by
        terminating your Jumaconnect Account, but your Content may persist in
        historical, archived or cached copies and versions thereof available on
        or through the Services. Although we have no obligation to monitor any
        Content, we have absolute discretion to remove Content at any time and
        for any reason without notice. You understand that by using the
        Services, you may be exposed to Content that is offensive, indecent, or
        objectionable. We take no responsibility and assume no liability for any
        Content, including any loss or damage to any of your Content.
      </p>
      <br/>

      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Communication: </strong> You consent to accept and receive
        communications from us, including e-mail, text messages, calls, and push
        notifications to the cellular telephone number you provide to us. These
        communications may be generated by automatic systems which will deliver
        messages, including for the purposes of secondary authentication,
        receipts, reminders and other notifications. You may opt-out of
        receiving communications from Jumaconnect Limited by following the
        unsubscribe options we provide to you. You acknowledge that opting out
        of receiving communications may impact your use of the Services.
      </p>
      <br/>

      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>
          Ownership, Intellectual Property, Copyright and Trademark
          Infringement:
        </strong>
        We reserve all rights not expressly granted to you in these General
        Terms. We own all rights, title, interest, copyright and other
        Intellectual Property Rights (as defined below) in the Services and all
        copies of the Services. These General Terms do not grant you any rights
        to our trademarks or service marks.
        <br />
        For the purposes of these General Terms, “Intellectual Property Rights”
        means all patent rights, copyright rights, mask work rights, moral
        rights, rights of publicity, trademark, trade dress and service mark
        rights, goodwill, trade secret rights, and other intellectual property
        rights that may exist now or come into existence in the future, and all
        of their applications, registrations, renewals and extensions,
        <br />
        under the laws of Ghana, country, territory or other jurisdiction.
        <br />
        You may submit comments or ideas about the Services (“Ideas”). By
        submitting any Idea, you agree that your disclosure is gratuitous,
        unsolicited, and without restriction, that it will not place us under
        any fiduciary, confidentiality or other obligation, and that we are free
        to use the Idea without any additional compensation to you, and/or to
        disclose the Idea on a non-confidential basis or otherwise to anyone.
      </p>
      <br/>

      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Security </strong>
        We have implemented technical and organizational measures designed to
        secure your personal information from accidental loss and from
        unauthorized access, use, alteration, or disclosure.
        <br />
        However, we cannot guarantee that unauthorized third parties will never
        be able to defeat those measures or use your personal information for
        improper purposes. You provide your personal information at your own
        risk. You are responsible for safeguarding your password and for
        restricting access to the Services from your compatible mobile devices
        and computer(s). You will immediately notify us of any unauthorized use
        of your password or Jumaconnect Account or any other breach of security.
        In the event of any dispute between two or more parties as to account
        ownership, we will be the sole arbiter of such dispute in our sole
        discretion. Our decision (which may include termination or suspension of
        any Jumaconnect Account subject to dispute) will be final and binding on
        all parties.
      </p>
      <br/>

      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Payment, Fees and Settlement: </strong>
        Jumaconnect is a payment facilitator that allows you to accept payments
        (Paystack) from clients for the payment for services. Jumaconnect is not
        a bank and do not offer banking services. In order to serve this
        purpose, we have entered into agreements with Paystack whose medium will
        be used for the payment transactions. In connection with the Payment
        Services, you authorize us to act as your agent for the limited purposes
        of holding, receiving, and disbursing funds on your behalf. Your
        authorizations will remain in full force and effect until your
        Jumaconnect Account is closed or terminated. We will remit to you funds
        actually received by us on your behalf, less amounts owed to us, subject
        to any Chargeback or reserve withheld or applied.
        <br />
        If you receive payment into your Jumaconnect Account, we will display
        the payment as a transaction in your transactions history. You should
        regularly reconcile incoming payments with your own records.
      </p>
      <br/>

      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Jumaconnect Account History: </strong>
        When a payment is made to your Jumaconnect Account, we will update your
        account activity on the web application and provide you a transaction
        confirmation. The confirmation will serve as your receipt. Summaries of
        your Jumaconnect Account activity, including monthly statements will be
        made available on our web application for a period. Except as required
        by law, you are solely responsible for compiling and retaining permanent
        records of all transactions and other data associated with your
        Jumaconnect Account and your use of the services and reconciling all
        transactional information that is associated with your Jumaconnect
        Account. If you believe that there is an error or unauthorized
        transaction activity is associated with your account, you must contact
        us immediately for redress.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Fees: </strong>All Fees charged must be paid in advance by
        clients via Paystack and held. Service Providers or service providers
        are paid or receive payment for work done after job completion and work
        done approval by the client. All Balances and all Fees, charges, and
        payments collected or paid through the Payment Services are denominated
        in Ghana cedis (GHS).
        <br />
        All Fees are exclusive of all taxes, and you indemnify and hold
        Jumaconnect harmless against any claims by any tax authority for any
        underpayment of any services, value added or other tax or levy, and any
        penalties and/or interest.
        <br />
        Jumaconnect will automatically initiate a settlement of Proceeds to your
        valid, linked bank account and (or) mobile money wallet at the end of
        the business day. Jumaconnectwill initiate a payout of Proceeds received
        on non-business days before the next business day.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Hold of Settlement: </strong>
        We may defer settlement payout or restrict access to your Proceeds if we
        need to conduct an investigation or resolve any pending dispute related
        to your use of the Service. We also may defer settlement or restrict
        access to your Proceeds as necessary to comply with applicable law or
        court order.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Chargeback / Refund Policy: </strong>
        You are responsible for all Reversals, Chargebacks, Claims, fees, fines,
        penalties and other liability incurred by Jumaconnect, a User, or a
        third party caused by or arising out of your breach of this Agreement.
        You agree to reimburse Jumaconnect, a User, or a third party for any and
        all such liability.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Off-Set Right: </strong>
        To the extent permitted by law, we may set off against the Balances for
        any obligation you owe us under any agreement with Jumaconnect (e.g.
        Chargebacks or refunds). If you owe us an amount that exceeds your
        Balance, we may charge or debit a payment instrument registered in your
        Jumaconnect Account or any connected Jumaconnect Account. Your failure
        to fully pay amounts that you owe us on demand will be a breach of these
        terms. You are liable for any of our costs associated with collection in
        addition to any amounts owed, including attorneys'fees and expenses,
        collection agency fees, and any applicable interest.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Automatic fraud detection: </strong>
        Jumaconnect employs advanced risk modeling to detect fraudulent
        transaction cues across Jumaconnect services. Fraudulent transactions
        are immediately cancelled after being detected. To protect you, any
        active service associated with anything fraudulent will be cancelled and
        payments made withheld.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Suspension: </strong>
        We may suspend your Jumaconnect Account at any time if we reasonably
        believe that your Jumaconnect Account has been compromised or for other
        security reasons; or We reasonably suspect your Jumaconnect Account to
        have been used or is being used without your authorization or
        fraudulently. We shall notify you either prior to the suspension or, if
        prior notification is not possible under the circumstances, promptly
        after the suspension unless we are prohibited by law to notify you.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Termination: </strong>
        We may at any time terminate your Jumaconnect Account without notice in
        case: You breach any condition of these Terms of Use or any other
        condition applicable to specific services covered by separate terms and
        conditions. This will be applicable after your failure to rectify a
        breach within a timeframe agreed between both parties.
        <br />
        If you violate or we have reason to believe that you are in violation of
        any law or regulation that is applicable to your use of our Services; or
        we have reason to believe that you are in any way involved in any
        fraudulent activity, money laundering, terrorism financing or other
        criminal activity.
        <br />
        The Client/Service Provider shall equally have the right to terminate
        this Agreement in the event Jumaconnect breaches any term of this
        Agreement.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Effect of Suspension or Termination: </strong>
        If these General Terms or your Jumaconnect Account is terminated or
        suspended for any reason: the license and any other rights granted under
        these General Terms and any Additional Terms will end.
        <br />
        We may (but have no obligation to) delete your information and account
        data stored on our servers.
        <br />
        We will not be liable to you or any third party for compensation,
        reimbursement, or damages for any termination or suspension of the
        Services, or for deletion of your information or account data.
        <br />
        Together with a termination notice or at any time thereafter, we may
        give you reasonable instructions on how to withdraw your remaining
        funds.
        <br />
        All rights granted to you under this Agreement shall cease and you must
        cease all activities authorized by this Agreement;
        <br />
        You will lose all rights to access the Portal, service and use of
        Hardware to accept payments.
        <br />
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Closure of Account: </strong>
        The closure of your Jumaconnect Account will cancel any pending
        transactions. Any funds that we are holding in custody for you at the
        time of closure, less any applicable Fees, will be paid out according to
        your settlement payout schedule, subject to the conditions in this
        Agreement. If an investigation is pending at the time you close your
        Jumaconnect Account, we may hold your funds as described herein. If you
        are later determined to be entitled to some or all of the funds, we will
        release those funds to you.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Your License: </strong>
        We grant you a limited, non-exclusive, revocable, non-transferable,
        non-sublicensable license to use the website that is part of the
        Services, as authorized in this General Terms. We may make website
        updates to the Services available to you. Any such website updates may
        be subject to additional terms to be made known to you at that time.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Governing Law: </strong>
        Notwithstanding anything herein contained, this Agreement is subject to
        any law, statute or agreement in force or which may come into force and
        become applicable to or binding on You or Jumaconnect, as the case may
        be including the Data Protection Act 2012, Act 843, the Electronic
        Transactions Act, 2008 (Act 772) as amended by Electronic Transactions
        (Amendment) Act, 2012, Act 838, the Electronic Communications Act 2008
        (Act 775) and the Electronic Communications Regulations 2011 (LI 1991)
        and any amendments in force. If anything herein contained is
        irreconcilable or contradictory to both Parties’ obligations under the
        aforesaid License, law or agreement, as the case may be, or should any
        Party commit any act or omit to do things such that other Party will be
        deemed to have contravened or be held to be in contravention of any term
        or condition of the License as the case may be, the affected Party shall
        be entitled to claim any loss incurred by way of penalty or otherwise,
        or in the case of material or substantial breach or contravention,
        terminate this Agreement as is provided for in this Agreement.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Indemnity: </strong>
        You will indemnify, defend, and hold Jumaconnect and its processors (and
        its respective employees, directors, agents, affiliates and
        representatives) harmless from and against any and all claims, costs,
        losses, damages, judgments, tax assessments, penalties, interest, and
        expenses (including without limitation reasonable attorneys’ fees)
        arising out of any claim, action, audit, investigation, inquiry, or
        other proceeding instituted by a person or entity that arises out of or
        relates to: any actual or alleged breach of your representations,
        warranties, or obligations set forth in these General Terms.
        <br />
        Your wrongful or improper use of the Services; your violation of any
        third-party right, including without limitation any right of privacy,
        publicity rights or Intellectual Property Rights; your violation of any
        law, rule or regulation of Ghana; and any other party’s access and/or
        use of the Services with your unique name, password or other appropriate
        security code.
        <br />
        Representations and Warranties: You represent and warrant to us that:
        you are at least eighteen (18) years of age;
        <br />
        you are eligible to register and use the Services and have the right,
        power, and ability to enter into and perform under these General Terms;
        <br />
        any information you provide in connection with the Services, including
        your business name, accurately and truthfully represents your business
        or personal identity under which you use Jumaconnect services;
        <br />
        you and all transactions initiated by you will comply with all the laws
        and regulations applicable to you and/or your business, including the
        Financial Services Act of Ghana;you will not use the Services, directly
        or indirectly, for any fraudulent undertaking or in any manner so as to
        interfere with the operation of the Services; and your use of the
        Services will be in compliance with these General Terms
        <br />
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>No Warranties: </strong>
        The use of “Jumaconnect” in this terms means Jumaconnect, (and their
        respective subsidiaries, affiliates, agents, directors, and employees).
        The services are provided “as is” without representation or warranty,
        whether it is express, implied, or statutory. Without limiting the
        foregoing, Jumaconnect specifically disclaims any implied warranties of
        merchantability, fitness for a particular purpose, or non-infringement.
        <br />
        Jumaconnect does not warrant or guarantee that the services are
        accurate, reliable or correct; that the services will meet your
        requirements; that the services will be available at any particular time
        or location, uninterrupted, error-free, without defect or secure; that
        any defects or errors will be corrected; or that the services are free
        of viruses or other harmful components.
        <br />
        Jumaconnect does not warrant, endorse, guarantee, or assume
        responsibility for any product or services advertised or offered by a
        third party. Jumaconnect does not have control of, or liability for,
        services that are paid for using the services.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Limitations of Liability and Damages: </strong>
        To the maximum extent permitted by applicable law, in no event will
        Jumaconnect be liable for any direct, indirect, punitive, incidental,
        special, consequential, or exemplary damages, including without
        limitation damages for loss of profits, goodwill, use, data, or other
        intangible losses, that result from the use of, inability to use, or
        unavailability of the service. In all cases, Jumaconnect will not be
        liable for any loss or damage that is not reasonably foreseeable. <br />
        Under no circumstances will Jumaconnect be responsible for any damage,
        loss, or injury resulting from hacking, tampering, or other unauthorized
        access or use of the services or your Jumaconnect account, or the
        information contained therein. This limitation of liability section
        applies whether the alleged liability is based on contract, tort,
        negligence, strict liability, or any other basis, even if Jumaconnect
        has been advised of the possibility of such damage. The foregoing
        limitation of liability will apply to the fullest extent permitted by
        law of Ghana.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Disputes: </strong>
        “Disputes” are defined as any claim, controversy, or dispute between you
        and Jumaconnect, its processors, suppliers or licensors (or their
        respective affiliates, agents, directors or employees), including any
        claims relating in any way to this General Terms, or the Services, or
        any other aspect of our relationship.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Arbitration: </strong>
        This Agreement shall be governed by, construed and interpreted in
        accordance with the laws of the Republic of Ghana. Any dispute or
        difference whatsoever between the parties which may arise out of or in
        connection with this Agreement shall be referred to arbitration and
        determined under the provisions of the Act 2010 (Act 798) or any
        statutory modification or replacement thereof. The Arbitration shall be
        held in such place and at such time as the arbitrator or empire may
        direct.
      </p>
      <br/>
      
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Governing Law: </strong>
        This General Terms and any Dispute shall be governed by, construed and
        interpreted per the laws of the Republic of Ghana.
      </p>
      <br/>

      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Assignment: </strong>
        These General Terms, and any rights and licenses granted hereunder, may
        not be transferred or assigned by you and any attempted transfer or
        assignment will be null and void.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Privacy and Security of Personal Data: </strong>
        We collect your data to enable us to provide you with our services. We
        have a Privacy Policy which explains how we collect, process, store and
        protect your data when you use our services. We will process your data
        and any personal data you provide to us according to our Privacy Policy,
        the Data Protection Act, 2012 (Act 843) and any applicable data
        protection law.
        <br />
        By using our Platform, you agree that we can process your data according
        to our Privacy Policy.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Restricted Access: </strong>
        Access to certain sections of our Platform may be restricted. We have
        the sole right and reserve the right to restrict your access to certain
        areas of our Platform. You agree that you will not access or attempt to
        access restricted areas reserved for administrative purposes, and
        secured or non-public areas on this website. You understand that you may
        be subject to prosecution should you attempt to access prohibited areas
        of our Platform.
      </p>
      <br/>

      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Availability: </strong>
        We will, within reasonable means, ensure that our Platform is
        continuously available. However, we do not guarantee that the service
        will be available all the time and will not be subject to interruption.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Advertising or Marketing: </strong>
        You agree that we may send you non-transactional and commercial
        information relating to services that may be of interest to you.
      </p>
      <br/>

      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Opting Out: </strong>
        If you no longer wish to receive e-mail announcements, notifications, or
        special promotions from us, kindly send an email to our helpdesk
        requesting for your contact information to be deleted from the mailing
        list
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Errors and Omissions: </strong>
        Information you access using a mobile device may contain typographical
        errors, errors of substance, or omission, whether or not material. We
        disclaim any responsibility for any damage or loss you incur while
        relying on the information you access using your mobile device. If you
        discover any such information please contact us using the information
        under the “Contact Information” section.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Severability: </strong>
        If any provision of these terms of service is deemed to be invalid or
        unenforceable, the remaining provision of these terms of service would
        remain in full force and effect.
        <br />
        If any provision of these terms of service is deemed invalid but would
        be valid and enforceable if part of the provision were deleted, then
        that provision will apply with the minimum modification necessary to
        make it valid and enforceable. The remaining provisions of these terms
        of service will remain in full force and effect.
      </p>
      <br/>

      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>No Waiver: </strong>
        Our failure to assert any right or enforce a provision under these terms
        shall not constitute a waiver of that right or the right to enforce a
        provision unless we expressly acknowledge and agree to do so in writing.
        If we fail to exercise a right or enforce any provisions of these terms
        of service, it shall not preclude or stop us from taking action in the
        future when a similar infringement occurs.
        <br />
        Contact Information: Please direct all questions and inquiries to the
        address and telephone numbers provided below;
        <br />
        Whatsapp us on: +233536782829
        <br />
        Email us on: support@Jumaconnect.com
        <br />
      </p>
      <br/>

      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Other Provisions: </strong>
        This General Terms is a complete statement of the agreement between you
        and Jumaconnect regarding the Services use.
        <br />
        In the event of a conflict between these General Terms, the General
        Terms will prevail and control the subject matter of such conflict.
        <br />
        If any provision of this General Terms is invalid or unenforceable under
        applicable law, then it will be changed and interpreted to accomplish
        the objectives of such provision to the greatest extent possible under
        applicable law, and the remaining provisions will continue in full force
        and effect.
        <br />
        This General Terms do not limit any rights that we may have under trade
        secret, copyright, patent, or other laws. No waiver of any term of this
        General Terms will be deemed a further or continuing waiver of such term
        or any other term.
        <br />
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Business Day </strong>
        means a weekday on which banks are open in Ghana.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>A claim </strong>
        is a demand, action or proceeding made or brought by or against the
        party, however arising and whether present, unascertained, immediate,
        future or contingent.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Client </strong>
        means on who seeks the services of the Service Provider Commencement
        Date means the date the parties enter into this Agreement.
        <br />
        Confidential Information means all information of a confidential nature,
        in any form whether tangible or not and whether visible or not,
        disclosed or communicated by a party to the other, or accessed by, or to
        which the other party is exposed as a result of entering into this
        Agreement and includes, without limitation, any information and material
        concerning the contractual or commercial dealings, financial details,
        products or services (current or proposed), customers, employees,
        internal policy, the Intellectual Property Rights of a party or dealings
        under this Agreement.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Consents </strong>
        means any licenses, clearances, permissions, certificates, permits,
        authorities, declarations, exemptions, waivers, approvals or consents.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Consequential Loss </strong>
        means any loss of profits, loss of income or revenue, loss of data, loss
        of or damage to reputation, loss of or damage to goodwill, loss of
        business opportunities (including opportunities to enter into or
        complete arrangements with third parties), loss of management time,
        damage to credit rating, or loss of business; and any loss, not arising
        naturally (that is according to the usual course of things), from the
        relevant breach, whether or not such loss is reasonably supposed to have
        been in the contemplation of both parties, at the time they made the
        Agreement, as the probable result of the relevant breach. Data means
        data (excluding Personal Information) that customer inputs into the
        Portal or provides to Jumaconnect or its Personnel by any other means or
        that is otherwise obtained by or on behalf of Jumaconnect or its
        Personnel via the Portal or by any other means.
      </p>
      <br/>

      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Derivative Materials </strong>
        means materials, data and insights derived or created by or on behalf of
        Jumaconnect or its Personnel in accordance with the terms, which are
        based on, or created or derived from, the Data.Documents means all
        online or hard copy documents, together with their accompanying
        supplemental information, made available to Client/Service Providers by
        Jumaconnect from time to time.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Dispute </strong>
        means a dispute between the parties arising in connection with this
        agreement.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Fees </strong>
        means the fees and expenses set out in an Order.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Governmental Agency</strong>
        means any government or any governmental, semi-governmental or judicial
        entity or authority. It also includes any self-regulatory organization
        established under a statute or any stock exchange.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Intellectual Property Rights </strong>
        means all industrial and intellectual property rights of any kind
        including but not limited to copyright (including rights in computer
        software), trademark, service mark, design, patent, trade secret,
        semi-conductor or circuit layout rights, trade, business, domain or
        company names, moral rights, rights in Confidential Information,
        know-how or other proprietary rights (whether or not any of these are
        registered and including any application, or right to apply, for
        registration) and all rights or forms of protection of a similar nature
        or having equivalent or similar effect to any of these which may subsist
        anywhere in the world.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Law </strong>
        means all laws including rules of common law, principles of equity,
        statutes, regulations, proclamations, ordinances, by-laws, rules,
        regulatory principles, requirements and determinations, mandatory codes
        of conduct, writs, orders, injunctions and judgments.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Personal Information </strong>
        means “personal information” as defined in the Privacy Act and any other
        information relating to individuals that is subject to the operation of
        the Privacy Laws that either party has collected, received or otherwise
        has access to in connection with this Agreement.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Personnel </strong>
        means in respect of a person any employee, contractor, servant, agent,
        or another person under the person’s direct or indirect control and
        includes any sub-contractors.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Portal </strong>
        means the web-based application which comprises the Jumaconnect online
        portal, the data supplied with the software and the associated media.
        Services means the services set out in an Order.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Services Fee </strong>
        means the fee charged by Jumaconnect for the provision of Services.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Service Provider means</strong>
        the one who performs the task or piece of work
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Tax </strong>
        includes any tax, levy, impost, deduction, charge, rate, duty,
        compulsory loan or withholding that is levied or imposed by a
        Governmental Agency, and any related interest, penalty, charge, fee or
        other amounts.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Term </strong>
        means the duration of time that this Agreement subsists between the
        parties.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Transaction Data </strong>
        is the written or electronic record of a Transaction, including but not
        limited to an authorization code or settlement record.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>Update </strong>
        means any update or upgrade to the Portal issued by Jumaconnect from
        time to time.Upgrade means any update or upgrade to the Hardware, as
        issued from time to time, including any upgrade to the operating system
        used on the Hardware.
      </p>
      <br/>
      <p className="font-normal font-inter text-base leading-6 tracking-normal text-justify">
        <strong>You </strong>
        means the Client or Service Provider
      </p>
      <br/>
    </div>
  );
};

export default Section3;
